import styled from "styled-components";

export const MySubText = styled.p`
    color: ${props => props.color};
    font-family: Roboto;
    font-size: 0.8rem;
`